import type { ApiResponse } from '@/types'

export const apiUtils = {
  // Handle API errors
  handleError: (error: unknown): string => {
    if (error && typeof (error as { message?: unknown }).message === 'string') {
      return (error as { message: string }).message
    }
    if (typeof error === 'string') {
      return error
    }
    return 'An unexpected error occurred'
  },

  // Format API response for UI with backward compatibility
  formatResponse: <T>(response: ApiResponse<T>) => {
    if (typeof response.success === 'boolean') {
      return {
        success: response.success,
        data: response.data,
        error: response.error,
        message: response.message,
        pagination: response.pagination,
      }
    }

    const hasError = response.error || (response as any).status === 'error'
    return {
      success: !hasError,
      data: response.data || (response as unknown as T),
      error: response.error,
      message: response.message,
      pagination: response.pagination,
    }
  },

  // Check if response is successful (with backward compatibility)
  isSuccess: <T>(
    response: ApiResponse<T>
  ): response is ApiResponse<T> & { success: true } => {
    if (typeof response.success === 'boolean') {
      return response.success === true
    }

    return !response.error && (response as any).status !== 'error'
  },
}
